(function (window, document) {
  'use strict';

  function initialize(root) {
    if (root.dataset.promotionReady === 'true') return;
    root.dataset.promotionReady = 'true';
    var expiresAt = new Date(root.dataset.expiresAt).getTime();
    var active = root.querySelector('[data-promotion-active]');
    var fallback = root.querySelector('[data-promotion-fallback]');
    var timer;

    function refresh() {
      if (timer) window.clearTimeout(timer);
      var remaining = expiresAt - Date.now();
      var open = Number.isFinite(remaining) && remaining > 0;
      active.hidden = !open;
      if (fallback) fallback.hidden = open;
      else root.hidden = !open;
      if (open) timer = window.setTimeout(refresh, Math.min(remaining, 2147483647));
    }

    refresh();
    document.addEventListener('visibilitychange', refresh);
  }

  document.querySelectorAll('[data-bd-masterclass-promotion]').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-bd-masterclass-promotion]').forEach(initialize);
  });
})(window, document);
